import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class LoggerService {
    private readonly isProd = environment.production;

    debug(message: string, ...args: any[]): void {
        if (!this.isProd) console.log(message, ...args);
    }

    warn(message: string, ...args: any[]): void {
        if (!this.isProd) console.warn(message, ...args);
    }

    error(message: string, ...args: any[]): void {
        console.error(message, ...args);
        const err = args[0] instanceof Error ? args[0] : undefined;
        Sentry.captureException(err ?? new Error(message), { extra: { args } });
    }
}
